var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4.5V8h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v6H2V2a2 2 0 0 1 2-2h5.5L14 4.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.588 13.692a.75.75 0 0 0-.276-.587 1.656 1.656 0 0 0-.403-.226 3.796 3.796 0 0 0-.61-.197 5.523 5.523 0 0 1-.998-.343 2.965 2.965 0 0 1-.699-.44 1.69 1.69 0 0 1-.412-.532 1.48 1.48 0 0 1-.136-.633c0-.263.061-.501.183-.715.122-.214.29-.397.506-.548.216-.151.47-.267.764-.347.294-.083.613-.124.956-.124.357 0 .682.047.975.141.297.094.552.226.764.394.213.171.379.374.497.608.12.234.178.49.178.77h-1.284a1.096 1.096 0 0 0-.084-.385.82.82 0 0 0-.211-.304 1.029 1.029 0 0 0-.361-.192 1.526 1.526 0 0 0-.497-.073c-.175 0-.331.02-.469.06-.134.037-.248.09-.342.158a.744.744 0 0 0-.216.253.683.683 0 0 0-.07.308.56.56 0 0 0 .094.317c.066.094.16.178.281.252.122.077.269.147.44.21.176.063.373.122.591.176.235.06.458.132.67.218.213.086.409.184.587.295.268.183.482.396.642.638.16.243.239.523.239.84 0 .273-.061.517-.183.731a1.59 1.59 0 0 1-.497.536 2.36 2.36 0 0 1-.76.338 3.918 3.918 0 0 1-.96.111c-.34 0-.678-.046-1.013-.137a2.723 2.723 0 0 1-.867-.411 2.07 2.07 0 0 1-.558-.625 1.696 1.696 0 0 1-.201-.843h1.294c.006.188.042.35.107.483a.872.872 0 0 0 .277.33c.116.086.255.149.417.188.166.04.347.06.544.06.175 0 .33-.018.464-.055a1.1 1.1 0 0 0 .347-.154.693.693 0 0 0 .215-.236.647.647 0 0 0 .075-.308ZM7.17 14.347h3.197v.972H5.848V9.086H7.17v5.26ZM2.784 11.32l1.214-2.234h1.547l-1.922 3.09 1.97 3.143H4.054l-1.252-2.27-1.247 2.27H0l1.969-3.143-1.917-3.09h1.537l1.195 2.234Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFile);
export default __webpack_public_path__ + "static/media/xls-file.508b496591d7eca620fca7a7405f4dca.svg";
export { ForwardRef as ReactComponent };